/*
 * GridSearch — the ONE shared list-search box (CLAUDE.md §18.6 / §7.5).
 * Every list form's search row uses the same `.list-search-row` / `.list-search`
 * markup (theme/boStandard.css) — previously hand-copied into ~40 pages. This
 * component is the single source of that markup so a new form drops it in
 * instead of re-typing it, and any future tweak (icon, clear button, layout)
 * lands everywhere at once.
 *
 *  Usage:
 *    <GridSearch value={search} onChange={setSearch} />
 *    <GridSearch value={search} onChange={setSearch} placeholder="Search across all columns…" />
 *    <GridSearch value={search} onChange={setSearch} right={<span>3 of 10 matched</span>} />
 */
import type { CSSProperties, ReactNode } from 'react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Extra content on the same row, right of the search box (e.g. a match count). */
  right?: ReactNode;
  /** Extra inline style on the `.list-search-row` (e.g. maximized-mode padding). */
  style?: CSSProperties;
}

export function GridSearch({ value, onChange, placeholder = 'Search…', right, style }: Props) {
  return (
    <div className="list-search-row" style={style}>
      <div className="list-search">
        <i className="ti ti-search" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <span className="list-search-clear" onClick={() => onChange('')}>×</span>
        )}
      </div>
      {right}
    </div>
  );
}
